<template>
    <!-- complete Modal -->
    <div class="modal custom-modal fade request-modal" id="complete-coach" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-md">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="form-header modal-header-title">
                        <h4 class="mb-0">Coach Booking Details<span class="badge bg-success ms-2">Complete</span>
                        </h4>
                    </div>
                    <a class="close" data-bs-dismiss="modal" aria-label="Close">
                        <span class="align-center" aria-hidden="true"><i class="feather-x"></i></span>
                    </a>
                </div>
                <div class="modal-body">

                    <!-- Court Request -->
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="card dashboard-card court-information">
                                <div class="card-header">
                                    <h4>Player Information</h4>
                                </div>
                                <div class="appointment-info">
                                    <ul class="appointmentset">
                                        <li>
                                            <div class="appointment-item">
                                                <div class="appointment-img">
                                                    <img src="@/assets/img/profiles/avatar-06.jpg" alt="User">
                                                </div>
                                                <div class="appointment-content">
                                                    <h6>Martina</h6>
                                                    <p>Since 05/05/2023</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <h6>Previosly Booked <i class="feather-alert-circle ms-1"></i></h6>
                                            <p>22 Jan 2023</p>
                                        </li>
                                        <li>
                                            <h6>No of Bookings</h6>
                                            <p>2</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="card dashboard-card court-information">
                                <div class="card-header">
                                    <h4>Coach Information</h4>
                                </div>
                                <div class="appointment-info">
                                    <ul class="appointmentset">
                                        <li>
                                            <div class="appointment-item">
                                                <div class="appointment-img">
                                                    <img src="@/assets/img/featured/featured-06.jpg" alt="Feature">
                                                </div>
                                                <div class="appointment-content">
                                                    <h6>Angela Roudrigez</h6>
                                                    <div class="table-rating">
                                                        <div class="rating-point">
                                                            <i class="fas fa-star filled"></i>
                                                            <i class="fas fa-star filled"></i>
                                                            <i class="fas fa-star filled"></i>
                                                            <i class="fas fa-star filled"></i>
                                                            <i class="fas fa-star filled"></i>
                                                            <span>30 Reviews</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <h6>Location</h6>
                                            <p>Santa Monica, CA</p>
                                        </li>
                                        <li>
                                            <h6>Price Per Hour</h6>
                                            <p><span class="color-green">$200.00</span> / hr</p>
                                        </li>
                                        <li>
                                            <h6>Rank</h6>
                                            <p>Expert</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="card dashboard-card court-information">
                                <div class="card-header">
                                    <h4>Appointment Information</h4>
                                </div>
                                <div class="appointment-info appoin-border">
                                    <ul class="appointmentset">
                                        <li>
                                            <h6>Booked On</h6>
                                            <p>Mon, Jul 14</p>
                                        </li>
                                        <li>
                                            <h6>Booking Type</h6>
                                            <p>Onetime</p>
                                        </li>
                                        <li>
                                            <h6>Date & Time</h6>
                                            <p>Mon, Jul 14
                                                <span>05:00 PM - 08:00 PM</span>
                                            </p>

                                        </li>
                                        <li>
                                            <h6>Total Number of Hours</h6>
                                            <p>2</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="card dashboard-card court-information">
                                <div class="card-header">
                                    <h4>Booking Days</h4>
                                </div>
                                <div class="booking-days">
                                    <ul>
                                        <li class="active">
                                            <img src="@/assets/img/icons/reset.svg" class="me-2" alt="Icon">
                                            <i class="feather-check-circle me-2"></i>
                                            14 May 2023 - 7:00 PM
                                            <i class="fa fa-check-circle ms-2"></i>
                                        </li>
                                        <li class="active">
                                            <img src="@/assets/img/icons/reset.svg" class="me-2" alt="Icon">
                                            <i class="feather-check-circle me-2"></i>
                                            15 May 2023 - 7:00 PM
                                            <i class="fa fa-check-circle ms-2"></i>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="card dashboard-card court-information">
                                <div class="card-header">
                                    <h4>Payment Details</h4>
                                </div>
                                <div class="appointment-info appoin-border double-row">
                                    <ul class="appointmentset">
                                        <li>
                                            <h6>Coaching Booking Amount</h6>
                                            <p>$200</p>
                                        </li>
                                        <li>
                                            <h6>Number of Hours</h6>
                                            <p>2</p>
                                        </li>
                                        <li>
                                            <h6>Service Charge</h6>
                                            <p>$20</p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="appointment-info appoin-border ">
                                    <ul class="appointmentset">
                                        <li>
                                            <h6>Total Amount Paid</h6>
                                            <p class="color-green">$180</p>
                                        </li>
                                        <li>
                                            <h6>Paid On</h6>
                                            <p>Mon, Jul 14</p>
                                        </li>
                                        <li>
                                            <h6>Transaction ID</h6>
                                            <p>#5464164445676781641</p>
                                        </li>
                                        <li>
                                            <h6>Payment type</h6>
                                            <p>Wallet</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="card dashboard-card court-information">
                                <div class="card-header">
                                    <h4>Review Details</h4>
                                </div>
                                <div class="user-review-details">
                                    <div class="user-review-img">
                                        <img src="@/assets/img/profiles/avatar-02.jpg" alt="User">
                                    </div>
                                    <div class="user-review-content">
                                        <div class="table-rating">
                                            <div class="rating-point">
                                                <i class="fas fa-star filled"></i>
                                                <i class="fas fa-star filled"></i>
                                                <i class="fas fa-star filled"></i>
                                                <i class="fas fa-star filled"></i>
                                                <i class="fas fa-star filled"></i>
                                                <span>5.0</span>
                                            </div>
                                        </div>
                                        <span><i class="fa fa-check me-2" aria-hidden="true"></i>Yes, I would book
                                            again.</span>
                                        <h6>Absolutely perfect</h6>
                                        <p>If you are looking for a perfect place for friendly matches with your
                                            friends or a competitive match, It is the best place.</p>
                                        <h5>Sent on 11/03/2023</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /Court Request -->

                </div>
                <div class="modal-footer">
                    <div class="table-accept-btn">
                        <a href="javascript:;" data-bs-dismiss="modal" class="btn cancel-table-btn">Cancel</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- /complete Modal -->

    <!-- complete Modal -->
    <div class="modal custom-modal fade request-modal" id="complete-court" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-md">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="form-header modal-header-title">
                        <h4 class="mb-0">Court Booking Details<span class="badge bg-success ms-2">Completed</span>
                        </h4>
                    </div>
                    <a class="close" data-bs-dismiss="modal" aria-label="Close">
                        <span class="align-center" aria-hidden="true"><i class="feather-x"></i></span>
                    </a>
                </div>
                <div class="modal-body">

                    <!-- Court Request -->
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="card dashboard-card court-information">
                                <div class="card-header">
                                    <h4>Court Information</h4>
                                </div>
                                <div class="appointment-info">
                                    <ul class="appointmentset">
                                        <li>
                                            <div class="appointment-item">
                                                <div class="appointment-img">
                                                    <img src="@/assets/img/booking/booking-03.jpg" alt="User">
                                                </div>
                                                <div class="appointment-content">
                                                    <h6>Wing Sports Academy</h6>
                                                    <p class="color-green">Court 1</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <h6>Booked On</h6>
                                            <p>$150 Upto 2 guests</p>
                                        </li>
                                        <li>
                                            <h6>Price Per Guest</h6>
                                            <p>$15</p>
                                        </li>
                                        <li>
                                            <h6>Maximum Number of Guests</h6>
                                            <p>2</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="card dashboard-card court-information">
                                <div class="card-header">
                                    <h4>Player Information</h4>
                                </div>
                                <div class="appointment-info">
                                    <ul class="appointmentset">
                                        <li>
                                            <div class="appointment-item">
                                                <div class="appointment-img">
                                                    <img src="@/assets/img/profiles/avatar-06.jpg" alt="User">
                                                </div>
                                                <div class="appointment-content">
                                                    <h6>Martina</h6>
                                                    <p>Court 1</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <h6>Previosly Booked <i class="feather-alert-circle ms-1"></i></h6>
                                            <p>22 Jan 2023</p>
                                        </li>
                                        <li>
                                            <h6>No of Bookings</h6>
                                            <p>2</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="card dashboard-card court-information">
                                <div class="card-header">
                                    <h4>Appointment Information</h4>
                                </div>
                                <div class="appointment-info appoin-border">
                                    <ul class="appointmentset">
                                        <li>
                                            <h6>Booked On</h6>
                                            <p>Mon, Jul 14</p>
                                        </li>
                                        <li>
                                            <h6>Date & Time</h6>
                                            <p>Mon, Jul 14<span class="d-block">05:00 PM - 08:00 PM</span></p>
                                        </li>
                                        <li>
                                            <h6>Total Number of Hours</h6>
                                            <p>2</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div class="card dashboard-card court-information">
                                <div class="card-header">
                                    <h4>Payment Details</h4>
                                </div>
                                <div class="appointment-info appoin-border double-row">
                                    <ul class="appointmentset">
                                        <li>
                                            <h6>Court Booking Amount</h6>
                                            <p>$150</p>
                                        </li>
                                        <li>
                                            <h6>Additional Guests</h6>
                                            <p>2</p>
                                        </li>
                                        <li>
                                            <h6>Amount Additional Guests</h6>
                                            <p>$30</p>
                                        </li>
                                        <li>
                                            <h6>Service Charge</h6>
                                            <p>$20</p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="appointment-info appoin-border ">
                                    <ul class="appointmentsetview">
                                        <li>
                                            <h6>Total Amount Paid</h6>
                                            <p class="color-green">$180</p>
                                        </li>
                                        <li>
                                            <h6>Paid On</h6>
                                            <p>Mon, Jul 14</p>
                                        </li>
                                        <li>
                                            <h6>Transaction ID</h6>
                                            <p>#5464164445676781641</p>
                                        </li>
                                        <li>
                                            <h6>Payment type</h6>
                                            <p>Wallet</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="card dashboard-card court-information">
                                <div class="card-header">
                                    <h4>Review Details</h4>
                                </div>
                                <div class="user-review-details">
                                    <div class="user-review-img">
                                        <img src="@/assets/img/profiles/avatar-01.jpg" alt="User">
                                    </div>
                                    <div class="user-review-content">
                                        <div class="table-rating">
                                            <div class="rating-point">
                                                <i class="fas fa-star filled"></i>
                                                <i class="fas fa-star filled"></i>
                                                <i class="fas fa-star filled"></i>
                                                <i class="fas fa-star filled"></i>
                                                <i class="fas fa-star filled"></i>
                                                <span>5.0</span>
                                            </div>
                                        </div>
                                        <span><i class="fa fa-check me-2" aria-hidden="true"></i>Yes, I would book
                                            again.</span>
                                        <h6>Absolutely perfect</h6>
                                        <p>If you are looking for a perfect place for friendly matches with your
                                            friends or a competitive match, It is the best place.</p>
                                        <h5>Sent on 11/03/2023</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /Court Request -->

                </div>
                <div class="modal-footer">
                    <div class="table-accept-btn">
                        <a href="javascript:;" data-bs-dismiss="modal" class="btn cancel-table-btn">Cancel</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- /complete Modal -->
</template>